import React from "react";
import { FormGroup, ContentBlock, Button, Icon,} from "xsolla-uikit";
import PAvi from "./PAvi";
import PAviGroup from "./PAviGroup";
import PAh2 from "../PAh2";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";

export default function PAvirtualItems({hist}) {
  return (
    <div>

      <FormGroup>
        <ContentBlock>

          <FormGroup indentation="lg">
            <div style={{ display: "flex", alignItems: "center" }}>
              <PAh2 title="Groups" indentation="xs"></PAh2>{" "}
              <CssCTA>
                <Link to="/microtransactions/new_group"><Button appearance="flatten"><Icon name="circle-plus" size={24}/></Button></Link>
              </CssCTA>
            </div>
          </FormGroup>



        <PAvi hist={hist} />
        </ContentBlock>
      </FormGroup>

      <FormGroup>
        <ContentBlock>

        <FormGroup indentation="lg">
            <div style={{ display: "flex", alignItems: "center" }}>
              <PAh2 title="Virtual items" indentation="xs"></PAh2>{" "}
              <CssCTA>
                <Link to="/microtransactions/new_item"><Button appearance="flatten"><Icon name="circle-plus" size={24}/></Button></Link>
              </CssCTA>
            </div>
          </FormGroup>


          <PAviGroup hist={hist} />
        </ContentBlock>
      </FormGroup>


    </div>
  )
}


const CssCTA = styled.div`
  /* flex-grow: 1; */
  display: flex;
  /* justify-content: flex-end; */
  margin-left: 1em;
  margin-top: 4px;
`;